<template>
  <div>
    FFFFFFFFFFFFFFFFFFFFFF
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";
import { ref, watch } from "vue";
import { fasFont } from '@quasar/extras/fontawesome-v5'

export default {
  name: 'Matrox',
  setup() {
    const slide = ref(1);
    const fullscreen = ref(false);

    const show_img = ref(false);

    return {
      slide,
      fullscreen,
      show_img
    }
  }
}
</script>